var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUniLiege = function SvgUniLiege(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.005 143.32",
    style: {
      enableBackground: "new 0 0 327.005 143.32"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".uni-liege_svg__st0{fill:#007680}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uni-liege_svg__st0",
    d: "M136.721 87.726h5.112v13.026c0 3.6 1.024 4.934 3.38 4.934 1.91 0 3.2-.89 4.844-3.022V87.726h5.114v21.826h-4.18l-.4-3.2h-.134c-1.91 2.268-4.044 3.734-7.024 3.734-4.666 0-6.712-3.154-6.712-8.668V87.726zM161.081 87.726h4.222l.356 2.936h.18c1.954-1.914 4.178-3.468 7.156-3.468 4.668 0 6.712 3.156 6.712 8.668v13.69h-5.112V96.528c0-3.6-1.024-4.934-3.422-4.934-1.914 0-3.158.934-4.98 2.71v15.248h-5.112V87.726zM186.285 87.726h5.112v21.826h-5.112zM195.22 87.726h5.202l3.466 11.336c.578 2.132 1.244 4.356 1.822 6.578h.18c.622-2.222 1.244-4.446 1.868-6.578l3.466-11.336h4.934l-7.422 21.826h-5.914l-7.602-21.826zM232.338 96.706c0-3.466-1.466-5.558-4.446-5.558-2.578 0-4.8 1.914-5.246 5.558h9.692zm-4.58-9.513c5.914 0 9.026 4.266 9.026 10.356 0 .98-.09 1.868-.222 2.402h-13.87c.444 3.956 2.934 6.18 6.444 6.18 1.868 0 3.468-.578 5.068-1.6l1.734 3.2c-2.09 1.378-4.712 2.356-7.468 2.356-6.044 0-10.758-4.224-10.758-11.426 0-7.113 4.934-11.468 10.046-11.468M242.117 87.726h4.222l.356 3.868h.18c1.554-2.846 3.866-4.4 6.178-4.4 1.112 0 1.822.132 2.488.442l-.888 4.446c-.756-.222-1.334-.356-2.268-.356-1.734 0-3.822 1.202-5.156 4.49v13.336h-5.112V87.726zM258.696 103.774c1.956 1.512 3.824 2.446 6.046 2.446 2.354 0 3.466-1.112 3.466-2.624 0-1.822-2.354-2.624-4.666-3.512-2.89-1.068-6.134-2.71-6.134-6.358 0-3.822 3.066-6.534 7.956-6.534 3.024 0 5.468 1.246 7.246 2.624l-2.356 3.112c-1.512-1.112-3.068-1.866-4.8-1.866-2.178 0-3.202 1.02-3.202 2.398 0 1.69 2.178 2.402 4.534 3.246 2.98 1.112 6.27 2.534 6.27 6.624 0 3.734-2.98 6.756-8.492 6.756-2.978 0-6.134-1.288-8.268-3.022l2.4-3.29zM278.122 87.726h5.112v21.826h-5.112zM291.102 91.771h-3.112v-3.824l3.378-.222.624-5.956h4.268v5.956h5.556v4.046h-5.556v10.402c0 2.578.978 3.824 3.066 3.824.756 0 1.644-.222 2.266-.49l.89 3.78c-1.2.4-2.712.8-4.446.8-5.068 0-6.934-3.2-6.934-7.914V91.771zM319.73 96.706c0-3.466-1.468-5.558-4.446-5.558-2.578 0-4.8 1.914-5.246 5.558h9.692zm-4.58-9.513c5.914 0 9.026 4.266 9.026 10.356 0 .98-.09 1.868-.222 2.402h-13.87c.444 3.956 2.934 6.18 6.444 6.18 1.868 0 3.468-.578 5.068-1.6l1.734 3.2c-2.09 1.378-4.712 2.356-7.468 2.356-6.046 0-10.758-4.224-10.758-11.426 0-7.113 4.934-11.468 10.046-11.468"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faa819"
    },
    d: "M29.608 63.179 2.829 78.64V47.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffce01"
    },
    d: "m2.829 78.64 26.778-15.46V94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f48245"
    },
    d: "m29.608 94.101-26.779 15.46v-30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee3a3d"
    },
    d: "m2.829 109.561 26.778-15.46v30.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e1db"
    },
    d: "M29.608 32.258 2.829 47.718v-30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bab9ab"
    },
    d: "m2.829 47.719 26.778-15.46v30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adcb7e"
    },
    d: "m56.386 47.719-26.778-15.46v30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77bf43"
    },
    d: "M29.608 63.179 56.386 78.64V47.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2da34a"
    },
    d: "M56.386 78.64 29.608 63.18V94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008d48"
    },
    d: "m29.608 94.101 26.778 15.46v-30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0066b2"
    },
    d: "m29.608 125.022 26.778 15.46v-30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00bedb"
    },
    d: "m56.386 109.561-26.778-15.46v30.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f5da4"
    },
    d: "m56.386 109.561 26.778 15.461V94.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b2c86"
    },
    d: "m83.164 125.022-26.778-15.46v30.92z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uni-liege_svg__st0",
    d: "m109.943 47.719-26.778 15.46v-30.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5ba3ad"
    },
    d: "m83.164 32.258 26.779-15.46v30.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585ea9"
    },
    d: "m109.943 109.561-26.778 15.461V94.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f9fd2"
    },
    d: "m83.164 94.101 26.779-15.46v30.92z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uni-liege_svg__st0",
    d: "M136.721 16.808h12.08v43.388h21.202v10.19h-33.282zM177.895 16.808h12.08v53.577h-12.08zM203.487 2.837h12.82l6.656 9.86h-9.614l-9.862-9.86zm-4.026 13.971h33.528v10.19h-21.448v10.764h18.242v10.11h-18.242v12.324h22.27v10.19h-34.35V16.808zM237.925 43.926c0-4.438.698-8.396 2.096-11.874 1.396-3.478 3.286-6.422 5.67-8.834 2.384-2.41 5.176-4.246 8.382-5.506 3.204-1.26 6.614-1.89 10.232-1.89 3.778 0 7.052.712 9.818 2.136 2.766 1.424 5.026 3.04 6.78 4.848l-6.656 7.478c-1.316-1.26-2.698-2.246-4.15-2.958-1.452-.712-3.328-1.068-5.63-1.068-2.082 0-3.984.398-5.71 1.192a12.889 12.889 0 0 0-4.478 3.41c-1.262 1.48-2.234 3.286-2.918 5.424-.686 2.136-1.028 4.548-1.028 7.23 0 5.534 1.246 9.82 3.74 12.862 2.492 3.04 6.258 4.56 11.298 4.56 1.096 0 2.166-.136 3.206-.412 1.04-.272 1.89-.684 2.548-1.23v-9.206h-8.876v-9.86h19.558V64.88c-1.918 1.808-4.438 3.342-7.56 4.602-3.122 1.26-6.574 1.89-10.354 1.89-3.616 0-6.998-.59-10.15-1.768-3.15-1.176-5.904-2.916-8.258-5.218-2.356-2.3-4.206-5.162-5.546-8.586-1.344-3.424-2.014-7.382-2.014-11.874M289.701 16.808h33.528v10.19h-21.448v10.764h18.242V47.87h-18.242v12.326h22.27v10.19h-34.35zM185.708 81.574c0-1.732 1.334-2.934 3.158-2.934 1.82 0 3.154 1.202 3.154 2.934 0 1.69-1.334 2.89-3.154 2.89-1.824 0-3.158-1.2-3.158-2.89M277.544 81.574c0-1.732 1.334-2.934 3.158-2.934 1.82 0 3.154 1.202 3.154 2.934 0 1.69-1.334 2.89-3.154 2.89-1.823 0-3.158-1.2-3.158-2.89M315.684 85.131h-3.78l3.958-6.492h5.112z"
  })));
};
export default SvgUniLiege;